import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://zukccndstrajedmltglv.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp1a2NjbmRzdHJhamVkbWx0Z2x2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI0MjQxMDYsImV4cCI6MjA2ODAwMDEwNn0.mmGEgNd7TIo9h0kxs9LzdWm0hBGTxx_GFGzw3OWs_Nc'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          email: string
          role: 'admin' | 'user'
          created_at: string
          updated_at: string
        }
        Insert: {
          id: string
          email: string
          role?: 'admin' | 'user'
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          email?: string
          role?: 'admin' | 'user'
          created_at?: string
          updated_at?: string
        }
      }
      products: {
        Row: {
          id: string
          item_ref: string
          name: string
          description: string | null
          unit: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          item_ref: string
          name: string
          description?: string | null
          unit: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          item_ref?: string
          name?: string
          description?: string | null
          unit?: string
          created_at?: string
          updated_at?: string
        }
      }
      barcodes: {
        Row: {
          id: string
          product_id: string
          barcode: string
          created_at: string
        }
        Insert: {
          id?: string
          product_id: string
          barcode: string
          created_at?: string
        }
        Update: {
          id?: string
          product_id?: string
          barcode?: string
          created_at?: string
        }
      }
      count_sessions: {
        Row: {
          id: string
          name: string
          description: string | null
          site: string
          status: 'pending' | 'active' | 'completed'
          created_by: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          name: string
          description?: string | null
          site: string
          status?: 'pending' | 'active' | 'completed'
          created_by: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          name?: string
          description?: string | null
          site?: string
          status?: 'pending' | 'active' | 'completed'
          created_by?: string
          created_at?: string
          updated_at?: string
        }
      }
      count_items: {
        Row: {
          id: string
          session_id: string
          product_id: string
          location: string
          lot: string | null
          expected_quantity: number
          actual_quantity: number | null
          counted_by: string | null
          counted_at: string | null
          status: 'pending' | 'in_progress' | 'completed'
          notes: string | null
          csv_line_number: number | null
          original_worksheet_id: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          session_id: string
          product_id: string
          location: string
          lot?: string | null
          expected_quantity: number
          actual_quantity?: number | null
          counted_by?: string | null
          counted_at?: string | null
          status?: 'pending' | 'in_progress' | 'completed'
          notes?: string | null
          csv_line_number?: number | null
          original_worksheet_id?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          session_id?: string
          product_id?: string
          location?: string
          lot?: string | null
          expected_quantity?: number
          actual_quantity?: number | null
          counted_by?: string | null
          counted_at?: string | null
          status?: 'pending' | 'in_progress' | 'completed'
          notes?: string | null
          csv_line_number?: number | null
          original_worksheet_id?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      found_items: {
        Row: {
          id: string
          session_id: string
          product_id: string
          location: string
          lot: string | null
          quantity: number
          found_by: string
          found_at: string
          notes: string | null
          created_at: string
        }
        Insert: {
          id?: string
          session_id: string
          product_id: string
          location: string
          lot?: string | null
          quantity: number
          found_by: string
          found_at?: string
          notes?: string | null
          created_at?: string
        }
        Update: {
          id?: string
          session_id?: string
          product_id?: string
          location?: string
          lot?: string | null
          quantity?: number
          found_by?: string
          found_at?: string
          notes?: string | null
          created_at?: string
        }
      }
    }
  }
} 